import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {

  constructor(private auth:AuthService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ui/toolbar/toolbar.component.ts